import * as yup from 'yup';

import { AssetType, OptionTokenDurationUnit } from '@blockpulse3/graphql/hooks';
import {
  dateField,
  numberField,
  requiredBooleanField,
  requiredDateField,
  requiredNumberField,
  requiredStringField,
} from '@blockpulse3/web-client/forms';

import { IOptionAsset } from './types';

export const optionAssetTypeOptions = [
  { label: AssetType.BSA, value: AssetType.BSA },
  { label: AssetType.BSA_AIR, value: AssetType.BSA_AIR },
  { label: AssetType.BSPCE, value: AssetType.BSPCE },
];

export const durationUnitOptions = [
  { label: OptionTokenDurationUnit.day, value: OptionTokenDurationUnit.day },
  { label: OptionTokenDurationUnit.month, value: OptionTokenDurationUnit.month },
];

export const schema = yup.object({
  name: requiredStringField,
  code: requiredStringField,
  type: yup.object({
    label: requiredStringField,
    value: requiredStringField,
  }),
  initialSupply: requiredNumberField,
  remainingSupply: numberField,
  date: requiredDateField,
  expirationDate: dateField,
  durationUnit: yup.object({
    label: requiredStringField,
    value: requiredStringField,
  }),
  attributionPeriod: requiredNumberField,
  subscriptionPeriod: requiredNumberField,
  subscriptionPrice: numberField,
  exercisePrice: requiredNumberField,
  conversionParity: requiredNumberField,
  delegated: requiredBooleanField,
  transferable: requiredBooleanField,
  accelerable: requiredBooleanField,
  approvable: requiredBooleanField,
  hasCurve: requiredBooleanField,
  cliffDuration: numberField,
  vestingDuration: numberField,
  intervalDuration: numberField,
}) as yup.ObjectSchema<IOptionAsset>;

export const defaultValues: IOptionAsset = {
  name: '',
  code: '',
  type: optionAssetTypeOptions[0],
  initialSupply: 0,
  remainingSupply: 0,
  date: '',
  expirationDate: '',
  durationUnit: durationUnitOptions[0],
  attributionPeriod: 0,
  subscriptionPeriod: 0,
  subscriptionPrice: 0,
  exercisePrice: 0,
  conversionParity: 0,
  delegated: false,
  transferable: false,
  accelerable: false,
  approvable: false,
  hasCurve: false,
  cliffDuration: 0,
  vestingDuration: 0,
  intervalDuration: 0,
};
